import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../../query/types';

const studentFeesConsumerStudentsPaymentsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'payments'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...key, uuid] as const,
        detail: [...key, uuid, 'detail'] as const,
      }),
  });
};

export { studentFeesConsumerStudentsPaymentsKeys };
